/* eslint-disable max-len */
/* eslint-disable class-methods-use-this */
import React from 'react';
import { useRouteData, useSiteData, Head } from 'react-static';
// template components
import Page from '@nmx/template/dist/componentLibrary/layout/Page';
// native components
import LegalLinks from '../../components/legalLinks';
import PageContent from './components/pageContent';

export default () => {
  const { config, dynamicConfig } = useSiteData();
  const { pageProps } = useRouteData();

  return (
    <Page
      {...pageProps} // defined in route.js
      headComponent={Head}
      dynamicConfig={dynamicConfig}
      config={config}
      breadcrumbsNavigationConfig={[
        {
          pageName: 'Home',
          linkUrl: '/',
          linkAriaLabel: 'Northwestern Mutual Home',
        },
        {
          pageName: 'Legal Information',
          linkUrl: '/legal-information/',
          linkAriaLabel: 'Northwestern Mutual Legal Information',
        },
      ]}
      disclaimerFootnotes={[
        <>
          <sup>1</sup> Retirement Income Policy, NN.RI.(0608) (Only available in Indiana, Minnesota, North Carolina, New Jersey and Texas).
        </>,
        <>
          <sup>2</sup> For Indiana, Minnesota, North Carolina, New Jersey and Texas, form NN.R.I.WP.(0608) (Retirement Income Policy) is also available.
        </>,
      ]}
      disableDisclaimerTopBorder>

      {/* PAGE CONTENT */}
      <PageContent />

      {/* LEGAL LINKS */}
      <LegalLinks />
    </Page>
  );
};
